import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

export const ChevronRight = (props: SvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 320 512"
      {...props}
    >
      <path
        fill={props.htmlColor || theme.palette.secondary[500]}
        d="M299.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 256 84.7 75.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l192 192z"
      />
    </SvgIcon>
  );
};
